import {betterMemo} from "js/common/utils/more-memo";
import React from "react";
import SimpleTextInput from "js/common/views/inputs/simple-text-input";

// Note: Similar to DelayedNameInput but allows longer names (up to 200 characters)
// Also fixes the jumping back and forth behaviour when slowly typing long names.
// TODO: Consider merging with DelayedNameInput in the future if appropriate.
const DelayedScheduleNameInput = betterMemo(
    {displayName: "DelayedScheduleNameInput"},
    ({value = "", onChange, disabled, errors}) => {
      const [str, setStr] = React.useState(value);
      React.useEffect(() => setStr(value), [value]);

      const timeoutIdRef = React.useRef(null);

      const flushChanges = () => {
        clearTimeout(timeoutIdRef.current);
        onChange(str.trim());
      };

      const handleChange = newStr => {
        setStr(newStr);

        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(() => {
          onChange(newStr);
        }, 300);
      };

      return <SimpleTextInput
          type="text"
          placeholder="Schedule Name"
          value={str}
          onClick={e => e.stopPropagation()}
          disabled={disabled}
          customStyle={() => scheduleNameInputStyle(errors)}
          onBlur={flushChanges}
          onChange={handleChange}
          maxLength={200} />;
    });

const scheduleNameInputStyle = (errors) => ({
  marginTop: 0,
  height: 42,
  width: "100%",
  ...(errors.get("name")
      && errors.get("name")
      !== "This field is required"
      && {border: "2px solid red"})
});

export default DelayedScheduleNameInput;